import { SET_FILTRO_LISTAGEM_USUARIO } from '../actions/usuario'

export const storageUsuario = 'usuario'

const initialState = {
    filtroListagem: {
        pageSize: 100,
        page: 1,
        filtro:'',
        order: 'nomeCompleto',
        filtroExpanded: false
    },
}

export const usuario = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTRO_LISTAGEM_USUARIO:
            return {
                ...state,
                filtroListagem: action.filtroListagem,
            }
        default:
            return state
    }
}
